import { useCmsBranches } from "@/hooks/use-cms";
import { FadeUp, StaggerContainer, StaggerItem } from "@/components/ui/scroll-animations";

const AsSeenOn = () => {
  const { data: branches, loading } = useCmsBranches();

  if (loading || branches.length === 0) return null;

  const activeBranches = branches.filter((b) => b.is_active);
  if (activeBranches.length === 0) return null;

  return (
    <section className="py-16 bg-primary">
      <div className="container-premium">
        <FadeUp>
          <div className="text-center mb-10">
            <span className="text-accent font-medium text-sm tracking-wide uppercase">
              Our Network
            </span>
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-primary-foreground mt-2">
              Service Across India
            </h2>
          </div>
        </FadeUp>

        <StaggerContainer className="flex flex-wrap justify-center items-center gap-4 md:gap-6 lg:gap-8" staggerDelay={0.05}>
          {activeBranches.map((branch) => (
            <StaggerItem key={branch.id}>
              <div className="px-6 py-3 bg-primary-foreground/10 rounded-lg opacity-80 hover:opacity-100 transition-all duration-300 hover:bg-primary-foreground/15 hover:scale-105">
                <span className="text-primary-foreground font-medium text-sm md:text-base">
                  {branch.name}
                </span>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
};

export default AsSeenOn;
